import React from 'react';
import { Send } from 'lucide-react';
import { primaryButton, secondaryButton } from '../ui';

type PublishDialogProps = {
  note: string;
  onNoteChange: (value: string) => void;
  onClose: () => void;
  onPublish: () => void;
  /** Overrides for reuse outside the form editor. */
  title?: string;
  description?: string;
  placeholder?: string;
};

export default function PublishDialog({
  note,
  onNoteChange,
  onClose,
  onPublish,
  title = 'Publish this form?',
  description = 'Your draft becomes the live version straight away. Earlier versions stay in history so you can roll back.',
  placeholder = 'e.g. Added serial number validation to step 2',
}: PublishDialogProps) {
  return (
        <div className="fixed inset-0 z-50 grid place-items-center bg-slate-900/40 p-4" role="dialog" aria-modal="true" aria-labelledby="publish-title">
          <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl">
            <h2 id="publish-title" className="text-base font-semibold text-slate-900">{title}</h2>
            <p className="mt-1 text-[12px] text-slate-500">{description}</p>
            <label className="mt-4 block text-[12px] font-medium text-slate-700">What changed in this release? <span className="font-normal text-slate-400">(optional)</span>
              <textarea value={note} onChange={(e) => onNoteChange(e.target.value)} maxLength={1000} rows={3} autoFocus
                placeholder={placeholder}
                className="mt-1 w-full rounded-lg border border-slate-200 p-2 text-[12px] outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100" />
            </label>
            <p className="mt-1 text-[11px] text-slate-400">This note is shown next to the version in Version history, to help others understand it later.</p>
            <div className="mt-5 flex justify-end gap-2">
              <button type="button" className={secondaryButton} onClick={() => onClose()}>Cancel</button>
              <button type="button" className={primaryButton} onClick={onPublish}><Send className="h-3.5 w-3.5" /> Publish</button>
            </div>
          </div>
        </div>
  );
}
